import React, { lazy, Suspense, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Breadcrumbs from './Breadcrumbs';
import SideBar from './SideBar';
import Dashboard from './Content/Dashboard';

// ✅ Load AllCandidates component
const AllCandidates = lazy(() => import('./Content/AllCandidate'));
const AddCandidate = lazy(() => import('./Content/AddCandidate'));
const CandidateProfile = lazy(() => import('./Content/UserAction/CandidateProfile'));


const getActiveMainFromPath = (pathname) => {
  if (pathname.startsWith('/Candidate-admin-home')) return 'dashboard';
  if (pathname.startsWith('/all-candidate')) return 'all-candidate';
   if (pathname.startsWith('/add-candidate')) return 'add-candidate';
   if (pathname.startsWith('/candidate-profile')) return 'candidate-profile';

  return 'dashboard';
};

export default function Content() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeMain, setActiveMain] = useState(() => getActiveMainFromPath(location.pathname));

  useEffect(() => {
    const newActiveMain = getActiveMainFromPath(location.pathname);
    if (newActiveMain !== activeMain) {
      setActiveMain(newActiveMain);
    }
  }, [location.pathname]);

  return (
    <div className="page-container">
      <div className="content-container">
        <SideBar
          activeMain={activeMain}
          setActiveMain={setActiveMain}
        />
        <div style={{ width: "100%" }}>
          <Breadcrumbs activeMain={activeMain} />
          <div>
            <Suspense fallback={<div>Loading...</div>}>
              {activeMain === 'dashboard' && <Dashboard />}
              {activeMain === 'all-candidate' && <AllCandidates />}
              {activeMain === 'add-candidate' && <AddCandidate />}
              {activeMain === 'candidate-profile' && <CandidateProfile />}

            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
}
